import { Component, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subject, takeUntil } from 'rxjs';
import { KeyboardService } from 'src/app/core/common/keyboard/keyboard.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { UiService } from 'src/app/core/services/ui.service';


@Component({
  selector: 'app-options',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.scss']
})
export class OptionsComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();
  option = ''
  filteredOptions: { value: string, display: SafeHtml | string, label: string }[] = [];
  options: { name: string, items: { value: string, display: SafeHtml | string, label: string }[] } = { name: '', items: [] }
  keyword = ''

  constructor(public ui: UiService, public viewContainerRef: ViewContainerRef, public keyboard: KeyboardService, public storage: StorageService, public domSanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    // this.keyboard.getInstance()?.onInput$
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((value) => {
    //     // console.log(value)
    //     // this.searchCountry(value);
    //     // this.keyword = value
    //     this.applyFilters()
    //   });
    // this.keyword.valueChanges.pipe(takeUntil(this.destroy$))
    //   .subscribe((value) => {
    //     this.applyFilters(value || '')
    //   })
    this.ui.option$.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      this.option = value
    })
    this.ui.options$.pipe(takeUntil(this.destroy$)).subscribe((value) => {
      // console.log(value)
      this.options = value
      this.options.items = this.options.items.map((item) => {
        item.display = this.domSanitizer.bypassSecurityTrustHtml(item.display as string)
        return item
      })
      this.applyFilters()
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  updateKeyword(event: Event) {
    this.keyword = (<HTMLInputElement>event.target).value
    this.applyFilters(this.keyword)
  }

  applyFilters(keyword = '') {
    this.filteredOptions = this.options.items.filter((item) => {
      return keyword == "" || item.label.toLowerCase().includes(keyword.toLowerCase());
    });
  }

  clickBack() {
    this.ui.option$.next('')
  }

  select_option(value: any) {
    this.ui.option$.next('')
    this.storage.set('ui.option', { key: this.options.name, value })
  }
}
